import React from "react";

function FieldValidationMessage(props:{message:string})
{
    return <div className="form-message-invalid fade-in">{props.message}</div>;
}

export default FieldValidationMessage;